// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__r3BAC","buttons":"PendingPaymentAlert_buttons__3XBXM"};